/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import Space from 'Modules/Space';
import { useField } from 'formik';
import { arrayOf, bool, func, node, shape, string } from 'prop-types';
import React from 'react';
import { Dropdown, Input } from 'semantic-ui-react';

import FieldLayout from '../FieldLayout/FieldLayout';

import styles from './InputWithTypeField.less';

const InputWithTypeField = ({
  field,
  options,
  label,
  prefixName,
  errorInline,
  onPrefixChange,
  inputWidthInPercent = 50,
  ...props
}) => {
  const { name } = field;
  const [inputField, , helpers] = useField(name);
  const [fieldPrefix, metaPrefix, helpersPrefix] = useField(prefixName);
  return (
    <div className={styles.inputWithType}>
      <FieldLayout
        name={name}
        label={label}
        errorInline={errorInline}
        prefixError={metaPrefix.error}
        isPrefixError={metaPrefix.touched && metaPrefix.error !== undefined}>
        <Space direction="horizontal" size={0}>
          <Input
            value={inputField.value}
            onChange={e => helpers.setValue(e.target.value ?? 'null')}
            onBlur={() => helpers.setTouched()}
            style={{ width: `${inputWidthInPercent}%`, zIndex: 1 }}
            {...props}
          />
          <div className={styles.prefix} style={{ width: `${100 - inputWidthInPercent}%` }}>
            <Dropdown
              fluid
              selection
              search
              options={options}
              value={fieldPrefix.value}
              clearable
              closeOnChange
              closeOnBlur
              onChange={(e, data) => {
                helpersPrefix.setValue(data.value);
                onPrefixChange?.(data);
              }}
            />
          </div>
        </Space>
      </FieldLayout>
    </div>
  );
};

InputWithTypeField.propTypes = {
  field: shape({}).isRequired,
  label: string,
  errorInline: bool,
  customLabel: node,
  prefixName: string.isRequired,
  onPrefixChange: func,
  options: arrayOf(shape({})).isRequired,
};

InputWithTypeField.defaultProps = {
  label: '',
  customLabel: null,
  errorInline: false,
  onPrefixChange: () => true,
};

export default InputWithTypeField;
